<template>
    <div class="banner-thumbnail bg-light border-0 p-2"
         v-bind:class="{ 'is-reordering': isReordering }">
        <div class="card rounded-0 border-0 shadow-sm overflow-hidden h-100">
            <div class="position-relative">
                <img class="w-100"
                     alt="banner"
                     v-bind:src="image">
                <div class="position-absolute slogan d-flex align-items-center"
                     v-bind:class="sloganAlignment">
                    <h5 class="font-weight-bolder rounded p-1 mb-0">
                        {{ slogan }}
                    </h5>
                </div>
            </div>
            <div class="card-footer text-right p-1">
                <button class="btn btn-sm btn-warning mr-1"
                        v-bind:class="{ 'btn-loading': isLoading }"
                        v-on:click="isModalEditBannerOpen = true">
                    編輯
                </button>
                <button class="btn btn-sm btn-danger"
                        v-bind:class="{ 'btn-loading': isLoading }"
                        v-on:click="deleteBanner">
                    刪除
                </button>
            </div>
        </div>

        <modal-banner is-editing
                      v-bind:banner="banner"
                      v-model="isModalEditBannerOpen">
        </modal-banner>
    </div>
</template>

<script>
import { apiNewVersion, apiUrl } from "../../config";

import ModalBanner from "./ModalBanner";

export default {
    name: "BannerThumbnail",
    components: {
        ModalBanner,
    },
    props: {
        isReordering: {
            type: Boolean,
            default: false,
        },
        banner: {
            type: Object,
        },
    },
    data () {
        return {
            isLoading: false,
            isModalEditBannerOpen: false,
        };
    },
    computed: {
        image () {
            return `${ apiUrl }/${ apiNewVersion }/banner/image/${ this.banner?.image ?? "" }`;
        },
        slogan () {
            return this.banner?.slogan ?? "";
        },
        alignment () {
            return this.banner?.alignment ?? "";
        },
        sloganAlignment () {
            return this.alignment === "left" ?
                "justify-content-start" :
                this.alignment === "right" ?
                    "justify-content-end" :
                    "justify-content-center";
        },
    },
    methods: {
        async deleteBanner () {
            this.isLoading = true;
            try {
                await this.$store.dispatch(
                    "banner/delete",
                    this.banner._id
                );
            } catch (e) {
                this.isLoading = false;
            }
            this.isLoading = false;
        },
    },
}
</script>

<style lang="scss" scoped>
.banner-thumbnail {
    .card {
        transition: transform 250ms ease-in-out;
    }

    &.is-reordering {
        animation-name: shake;
        animation-duration: 1250ms;
        animation-iteration-count: infinite;
        cursor: grab;
    }

    &:not(.is-reordering) {
        .card {
            &:hover,
            &:focus {
                transform: scale(1.05);
            }
        }
    }

    @keyframes shake {
        from,
        to {
            transform: translate3d(0, 0, 0);
        }

        10%,
        30%,
        50%,
        70%,
        90% {
            transform: translate3d(-2.5px, 0, 0);
        }

        20%,
        40%,
        60%,
        80% {
            transform: translate3d(2.5px, 0, 0);
        }
    }
}

img  {
    height: 275px;
    object-fit: contain;
}

.slogan {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    h5 {
        background-color: rgba(255, 255, 255, 0.5);
        backdrop-filter: blur(2.5px);
    }
}
</style>
